export const newsSelector = state => state.news.list;
export const totalNewsSelector = state => state.news.total;

export const getNewsFetchSelector = state => state.news.fetching.getNews;
export const createNewsFetchSelector = state => state.news.fetching.createNews;
export const updateNewsFetchSelector = state => state.news.fetching.updateNews;
export const deleteNewsFetchSelector = state => state.news.fetching.deleteNews;
